(function () {
  var STORAGE_KEY = "theme_cookie_consent_v1";
  var CONSENT_EVENT = "theme:cookie-consent:updated";

  function safeParse(value) {
    try { return JSON.parse(value); } catch (e) { return null; }
  }

  // localStorage kann werfen statt nur leer zu sein: im Privatmodus, bei
  // blockierten Drittanbieter-Cookies und vor allem in der Theme-Vorschau,
  // die im Admin in einem iframe laeuft. Ungeschuetzt riss das init() ab,
  // bevor die Klick-Handler haengen - die Buttons blieben wirkungslos.
  function readStored() {
    try { return localStorage.getItem(STORAGE_KEY); } catch (e) { return null; }
  }

  function writeStored(value) {
    try { localStorage.setItem(STORAGE_KEY, value); } catch (e) {}
  }

  function getSavedConsent() {
    var parsed = safeParse(readStored());
    if (!parsed || typeof parsed !== "object") return null;
    if (!("analytics" in parsed) || !("marketing" in parsed)) return null;
    return parsed;
  }

  function saveConsent(consent) {
    writeStored(JSON.stringify(consent));
  }

  // Google Consent Mode. Das Google-Tag der Google-&-YouTube-App laeuft direkt
  // auf der Seite und liest window.dataLayer mit. Default und gespeicherte
  // Auswahl setzt schon das Inline-Skript in theme.liquid vor dem Tag; hier
  // kommt nur noch das Update nach einem Klick im Banner.
  function setConsentMode(consent) {
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
    window.gtag("consent", "update", {
      ad_storage: consent.marketing ? "granted" : "denied",
      ad_user_data: consent.marketing ? "granted" : "denied",
      ad_personalization: consent.marketing ? "granted" : "denied",
      analytics_storage: consent.analytics ? "granted" : "denied"
    });
  }

  // Shopify's native pixels (Google & YouTube channel, GA4/Ads, etc.) only fire
  // when consent is reported through Shopify's Customer Privacy API. Without this,
  // Shopify keeps consent denied and no analytics data is collected.
  function applyShopifyConsent(consent) {
    var payload = {
      analytics: !!consent.analytics,
      marketing: !!consent.marketing,
      preferences: !!consent.marketing,
      sale_of_data: !!consent.marketing
    };

    function push() {
      try {
        window.Shopify.customerPrivacy.setTrackingConsent(payload, function () {});
      } catch (e) {}
    }

    if (window.Shopify && window.Shopify.customerPrivacy && window.Shopify.customerPrivacy.setTrackingConsent) {
      push();
    } else if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures(
        [{ name: "consent-tracking-api", version: "0.1" }],
        function (error) {
          if (!error) push();
        }
      );
    }
  }

  function loadDeferredScripts(consent) {
    var scripts = document.querySelectorAll('script[type="text/plain"][data-consent]:not([data-consent-loaded])');
    scripts.forEach(function (blockedScript) {
      var category = blockedScript.getAttribute("data-consent");
      var allowed = category === "necessary" || !!consent[category];
      if (!allowed) return;

      var script = document.createElement("script");
      Array.prototype.forEach.call(blockedScript.attributes, function (attr) {
        if (
          attr.name === "type" ||
          attr.name === "data-consent" ||
          attr.name === "data-consent-src" ||
          attr.name === "data-consent-loaded"
        ) return;
        script.setAttribute(attr.name, attr.value);
      });

      var consentSrc = blockedScript.getAttribute("data-consent-src");
      if (consentSrc) {
        script.src = consentSrc;
      } else {
        script.text = blockedScript.textContent;
      }

      blockedScript.setAttribute("data-consent-loaded", "true");
      blockedScript.parentNode.insertBefore(script, blockedScript.nextSibling);
    });
  }

  function dispatchConsentEvent(consent) {
    window.dispatchEvent(new CustomEvent(CONSENT_EVENT, { detail: consent }));
  }

  function init() {
    var root = document.querySelector("[data-cookie-consent-root]");
    if (!root) return;

    var bannerView = root.querySelector('[data-cookie-consent-view="banner"]');
    var settingsView = root.querySelector('[data-cookie-consent-view="settings"]');
    var toggles = root.querySelectorAll("[data-cookie-consent-category]");
    var state = getSavedConsent();

    function focusFirst(view) {
      var first = view && view.querySelector("input:not([disabled]), button");
      if (first) first.focus();
    }

    // Schalter zeigen die gespeicherte Auswahl; ohne Auswahl ist alles aus.
    function syncToggles() {
      Array.prototype.forEach.call(toggles, function (toggle) {
        toggle.checked = !!(state && state[toggle.getAttribute("data-cookie-consent-category")]);
      });
    }

    function showView(name) {
      if (bannerView) bannerView.hidden = name !== "banner";
      if (settingsView) settingsView.hidden = name !== "settings";
      focusFirst(name === "settings" ? settingsView : bannerView);
    }

    // Nach einer Auswahl blendet die Klasse cookie-consent-resolved (in
    // theme.liquid gesetzt) das Banner per CSS aus. Zum erneuten Oeffnen ueber
    // "Cookie-Einstellungen" im Footer muss sie weg, sonst bleibt es unsichtbar.
    function open(view) {
      document.documentElement.classList.remove("cookie-consent-resolved");
      root.hidden = false;
      if (view === "settings") syncToggles();
      showView(view || "banner");
    }
    function hide() { root.hidden = true; }

    function applyConsent(consent) {
      // Erst Zustand sichern und schliessen, dann die Folgeschritte: wirft
      // einer davon, ist die Auswahl trotzdem gespeichert und das Banner weg.
      // Bereits geladene Skripte lassen sich nicht entladen: wird eine
      // Einwilligung zurueckgenommen, laedt die Seite neu.
      var revoked = !!(state && ((state.analytics && !consent.analytics) || (state.marketing && !consent.marketing)));
      saveConsent(consent);
      state = consent;
      hide();
      setConsentMode(consent);
      applyShopifyConsent(consent);
      loadDeferredScripts(consent);
      dispatchConsentEvent(consent);
      if (revoked) window.location.reload();
    }

    function on(selector, handler) {
      Array.prototype.forEach.call(root.querySelectorAll(selector), function (el) {
        el.addEventListener("click", handler);
      });
    }

    on("[data-cookie-consent-accept]", function () {
      applyConsent({ analytics: true, marketing: true, updated_at: Date.now() });
    });
    on("[data-cookie-consent-reject]", function () {
      applyConsent({ analytics: false, marketing: false, updated_at: Date.now() });
    });
    on("[data-cookie-consent-customize]", function () {
      syncToggles();
      showView("settings");
    });
    on("[data-cookie-consent-save]", function () {
      var consent = { analytics: false, marketing: false, updated_at: Date.now() };
      Array.prototype.forEach.call(toggles, function (toggle) {
        consent[toggle.getAttribute("data-cookie-consent-category")] = toggle.checked;
      });
      applyConsent(consent);
    });
    // Abbrechen ohne bisherige Auswahl fuehrt zurueck zum Banner, denn eine
    // Entscheidung steht noch aus. Mit Auswahl bleibt alles beim Alten.
    function cancel() {
      if (state) hide();
      else showView("banner");
    }
    on("[data-cookie-consent-cancel]", cancel);
    if (settingsView) {
      settingsView.addEventListener("keydown", function (event) {
        if (event.key === "Escape") cancel();
      });
    }

    // Der Footer-Link oeffnet direkt die Kategorien mit der aktuellen Auswahl.
    window.openCookieSettings = function () { open("settings"); };
    window.themeCookieConsent = {
      open: open,
      get: function () { return state; },
      canUse: function (category) {
        return category === "necessary" || !!(state && state[category]);
      }
    };

    if (state) {
      applyShopifyConsent(state);
      loadDeferredScripts(state);
      dispatchConsentEvent(state);
      hide();
    } else {
      open("banner");
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
